import { styled } from '@uhg-abyss/web/tools/styled';
import { Accordion } from '@uhg-abyss/web/ui/Accordion';

import { Markdown } from '../../../common/Markdown';

export const accordionHeader = {
  'abyss-accordion-header': {
    fontSize: '16px',
    fontWeight: 'bold !important',
    lineHeight: '19.2px !important',
  },
};

export const AccordionItem = styled(Accordion.Item, {
  gap: '16px !important',
  '.abyss-accordion-trigger': {
    borderBottomColor: '#CBCCCD !important',
    borderBottomWidth: '0.5px !important',
    backgroundColor: 'white',
    '&:hover, &:focus, &.active, &.selected': {
      backgroundColor: '$core.color.brand.5 !important',
    },
    '&.open': {
      backgroundColor: '$core.color.brand.5 !important',
    },
    '&[data-state="open"]': {
      backgroundColor: '$core.color.brand.5 !important',
    },
  },
  '.abyss-chevron-icon': {
    color: '$core.color.brand.100 !important',
  },
});

export const accordionContent = {
  'abyss-accordion-content-text': {
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '22.4px',
    color: '#4B4D4F !important',
  },
  'abyss-accordion-content-container': {
    borderBottom: '0.5px solid #CBCCCD !important',
  },
};

export const StyledMarkdown = styled(Markdown, {
  'abyss-layout-stack': {
    paddingTop: '8px',
  },
  '.abyss-icon-symbol': {
    fontSize: '18px !important',
    paddingTop: '2px',
    color: '$core.color.brand.60 !important',
  },
  '.abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    borderColor: 'white !important',
  },
  '.abyss-flex-root': {
    paddingLeft: '5px',
  },
  '.abyss-accordion-trigger': {
    border: 'none',
    padding: '0px',
  },
});
export const healthPremiumLinkStyle = {
  'abyss-link-root': {
    fontSize: '14px',
    lineHeight: '18px',
    borderColor: 'white !important',
  },
};

export const accordionItemImages = {
  '.abyss-accordion-trigger': {
    backgroundColor: 'white',
    border: 'none',
    padding: '0 0 0 5px',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: 'white !important',
    },
  },
  '.abyss-accordion-trigger, .abyss-accordion-header-trigger': {
    padding: '0px 0px 0px 5px !important',
    marginLeft: '5px !important',
  },
  // Matches the CMS "(Web)" <summary> text style so the App accordion header looks the same.
  '.abyss-accordion-header': {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '$core.color.brand.100 !important',
  },
  '.abyss-chevron-icon': {
    color: '$core.color.brand.100 !important',
  },
};

// Styles the CMS-authored raw <details>/<summary> HTML to match the real Abyss accordion look,
export const StyledDetailsMarkdown = styled(Markdown, {
  details: {
    marginTop: '16px',
    marginBottom: '16px',
  },
  summary: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '14px',
    cursor: 'pointer',
    fontSize: '16px',
    color: '$core.color.brand.100 !important',
    borderBottom: '1px solid #CBCCCD',
    width: 'fit-content',
    padding: '0 5px',
    '&:hover': {
      backgroundColor:
        'var(--abyss-colors-accordion-color-surface-header-default-hover) !important',
    },
    '&::-webkit-details-marker': {
      display: 'none',
    },
    '&::after': {
      content: '""',
      display: 'inline-block',
      width: '8px',
      height: '8px',
      borderRight: '2px solid currentColor',
      borderBottom: '2px solid currentColor',
      borderRadius: '0px 1px 1px 1px',
      transform: 'rotate(45deg)',
      transition: 'transform 0.2s ease',
    },
  },
  'details[open] summary::after': {
    transform: 'rotate(225deg)',
  },
});
